<template>
    <content-string-create :client-id="clientId" :back-route="{ name: 'client-content-strings', params: { clientId: clientId } }" />
</template>
<script>
import ContentStringCreate from '../../../../common/content/string/content-string-create.vue'

export default {
    name: 'system-content-strings-create',
    components: { ContentStringCreate },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/content/strings/create.vue